import { Tooltip } from '@material-ui/core';
import { MaterialTableProps } from 'material-table';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import TableLayout from '../../../../components/Layout/TableLayout';
import { formatNumber } from '../../../../helpers/formatNumber';
import { tFormKey, tKey } from '../../../../helpers/translate';
import { InvoiceListItem } from '../../../../redux/accounting/definitions';
import { showSnackbar } from '../../../../redux/FeedbackAPI/actions';
import { SeveritySnackbar } from '../../../../redux/FeedbackAPI/definitions';
import EntityMenuRight from '../../../Entities/EntityMenuRight/EntityMenuRight';
import AccountingSubmenu from '../../AccountingSubmenu';
import useInvoiceList from '../hooks/useInvoiceList';
import InvoicesList from './InvoicesList';

interface ActiveInvoicesListProps {
  accountingLoading: boolean;
  downloadInvoice: (file_id: number, filename: string) => void;
  showSnackbar: (message: string, severity: SeveritySnackbar) => void;
}

const ActiveInvoicesList: React.FC<ActiveInvoicesListProps> = ({ accountingLoading, showSnackbar }) => {
  const { loading, invoices, errorListMessage, stateFilters } = useInvoiceList('active', accountingLoading);

  useEffect(() => {
    if (errorListMessage) {
      showSnackbar(errorListMessage, 'error');
    }
  }, [errorListMessage, showSnackbar]);

  const tableData: MaterialTableProps<InvoiceListItem> = {
    title: tFormKey('activeInvoicesList.title'),
    columns: [
      {
        field: 'reference_number',
        title: tKey('Factura'),
        render: rowData => (
          <Tooltip title={rowData.reference_number}>
            <span>{rowData.reference_number}</span>
          </Tooltip>
        ),
        //@ts-ignore
        width: '120px',
      },
      {
        field: 'entity_name',
        title: tKey('Proveedor'),
        render: rowData => (
          <Tooltip title={rowData.entity_name}>
            <span>{rowData.entity_name}</span>
          </Tooltip>
        ),
        //@ts-ignore
        width: '200px',
      },
      {
        field: 'invoice_date',
        title: tFormKey('Fecha'),
        headerStyle: {
          textAlign: 'center',
        },
        cellStyle: {
          textAlign: 'center',
        },
        render: (rowData: InvoiceListItem) => <div style={{ textAlign: 'center' }}>{rowData.invoice_date}</div>,
        //@ts-ignore
        width: '110px',
      },
      {
        field: 'total_amount',
        title: tKey('Total'),
        type: 'numeric',
        render: (rowData: InvoiceListItem) => <div>{formatNumber({ value: rowData.total_amount }) + ' €'}</div>,
        //@ts-ignore
        width: '100px',
      },
      {
        field: 'center_costs',
        title: tKey('Centro de coste'),
        render: rowData => (
          <Tooltip title={rowData.center_costs}>
            <span>{rowData.center_costs}</span>
          </Tooltip>
        ),
        //@ts-ignore
        width: '180px',
      },
      {
        field: 'state',
        title: tKey('Estado'),
        //@ts-ignore
        width: '100px',
        lookup: stateFilters,
      },
    ],
    data: invoices,
    options: {
      tableLayout: 'auto',
      pageSize: 50,
      pageSizeOptions: [20, 50, 100],
    },
  };

  tableData.isLoading = loading || accountingLoading;

  const rightSubmenu = <EntityMenuRight actionButtons={[]} />;

  return (
    <TableLayout
      leftSubmenu={<AccountingSubmenu selected={'current_invoices'} submenu={tKey('Facturas servicios')} />}
      rightSubmenu={rightSubmenu}
    >
      <InvoicesList tableData={tableData} downloadAction />
    </TableLayout>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  showSnackbar: (message: string, severity: SeveritySnackbar): void => dispatch(showSnackbar(message, severity)),
});

export default connect(() => ({}), mapDispatchToProps)(ActiveInvoicesList);
